import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import styles from './labeledValue.module.scss';
import clsx from 'clsx';

const LabeledValue = ({ label, value }) => {
    return (
        <div>
            <Typography
                className={clsx(styles.truncatedText)}
                fontFamily="InstrumentSans-semibold"
                sx={{
                    fontSize: '20px',
                    lineHeight: '100%',
                    letterSpacing: '-0.4px'
                }}>
                {value}
            </Typography>
            <Typography
                className={clsx(styles.truncatedText, styles.label)}
                sx={{
                    fontSize: '16px',
                    lineHeight: 1.2,
                    letterSpacing: '-0.16px',
                    opacity: 0.5
                }}>
                {label}
            </Typography>
        </div>
    );
};

LabeledValue.propTypes = {
    label: PropTypes.string,
    value: PropTypes.node
};

export default LabeledValue;
